export default __webpack_public_path__ + "static/media/img--exterior-corner.0eeef372.jpg";